import type { CropImageAroundBbox } from "./types";

const DEFAULT_PADDING_RATIO = 0.35;
const DEFAULT_OUTPUT_SIZE_PX = 32;
const DEFAULT_BACKGROUND_COLOR = "#ffffff";

export const cropImageAroundBbox: CropImageAroundBbox = ({
  sourceImage,
  bbox,
  sourceWidthPx,
  sourceHeightPx,
  paddingRatio = DEFAULT_PADDING_RATIO,
  outputSizePx = DEFAULT_OUTPUT_SIZE_PX,
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
}) => {
  const bboxWidth = bbox.x2 - bbox.x1;
  const bboxHeight = bbox.y2 - bbox.y1;

  if (bboxWidth <= 0 || bboxHeight <= 0) {
    return "";
  }

  if (sourceWidthPx <= 0 || sourceHeightPx <= 0) {
    return "";
  }

  const bboxCenterXDisplay = bbox.x1 + bboxWidth / 2;
  const bboxCenterYDisplay = bbox.y1 + bboxHeight / 2;
  const maxBboxDimension = Math.max(bboxWidth, bboxHeight);

  const sourceSideDisplay = Math.min(
    Math.max(maxBboxDimension * (1 + paddingRatio * 2), 1),
    Math.min(sourceWidthPx, sourceHeightPx),
  );

  const naturalScaleX = sourceImage.naturalWidth / sourceWidthPx;
  const naturalScaleY = sourceImage.naturalHeight / sourceHeightPx;

  const sourceSideNatural =
    sourceSideDisplay * Math.min(naturalScaleX, naturalScaleY);
  const bboxCenterXNatural = bboxCenterXDisplay * naturalScaleX;
  const bboxCenterYNatural = bboxCenterYDisplay * naturalScaleY;

  const maxSourceXNatural = Math.max(
    0,
    sourceImage.naturalWidth - sourceSideNatural,
  );
  const maxSourceYNatural = Math.max(
    0,
    sourceImage.naturalHeight - sourceSideNatural,
  );

  const sourceXNatural = Math.max(
    0,
    Math.min(maxSourceXNatural, bboxCenterXNatural - sourceSideNatural / 2),
  );
  const sourceYNatural = Math.max(
    0,
    Math.min(maxSourceYNatural, bboxCenterYNatural - sourceSideNatural / 2),
  );

  const canvas = document.createElement("canvas");
  canvas.width = outputSizePx;
  canvas.height = outputSizePx;

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return "";
  }

  ctx.imageSmoothingQuality = "high";
  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, outputSizePx, outputSizePx);

  try {
    ctx.drawImage(
      sourceImage,
      sourceXNatural,
      sourceYNatural,
      sourceSideNatural,
      sourceSideNatural,
      0,
      0,
      outputSizePx,
      outputSizePx,
    );
    return canvas.toDataURL("image/png");
  } catch {
    return "";
  }
};
